(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faqs-swiper-container').forEach(function (root) {
      const viewport = root.querySelector('.faqs-swiper-viewport');
      const track = root.querySelector('.faqs-swiper-track') || root.querySelector('.swiper-wrapper');
      if (!viewport || !track) return;

      const logicalContainer = root.closest('.page__container') || root;
      let prevBtn = logicalContainer.querySelector('.recos-prev');
      let nextBtn = logicalContainer.querySelector('.recos-next');
      let dotsWrap = logicalContainer.querySelector('.swiper-pagination');
      if (!prevBtn) prevBtn = root.querySelector('.recos-prev');
      if (!nextBtn) nextBtn = root.querySelector('.recos-next');
      if (!dotsWrap) {
        dotsWrap = document.createElement('div');
        dotsWrap.className = 'swiper-pagination';
        logicalContainer.appendChild(dotsWrap);
      }

      /* --- Fallback: parse FAQs from collection description if no metafield slides --- */
      var originalNodes = Array.from(track.querySelectorAll('.swiper-slide'));
      if (originalNodes.length === 0) {
        var tpl = root.querySelector('template.faqs-from-description');
        if (tpl) {
          var frag = document.createElement('div');
          frag.innerHTML = tpl.innerHTML;
          var containers = frag.querySelectorAll('.accordion-body .container');
          containers.forEach(function (c, idx) {
            var labelEl = c.querySelector('.label');
            var contentEls = c.querySelectorAll('.content');
            if (!labelEl || contentEls.length === 0) return;
            var answer = '';
            contentEls.forEach(function (ce) {
              var txt = ce.innerHTML.trim();
              if (txt && txt !== '<br>' && txt !== '<br>') answer += txt + ' ';
            });
            answer = answer.trim();
            if (!answer) return;
            var slide = document.createElement('div');
            slide.className = 'swiper-slide faq-item';
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-roledescription', 'slide');
            slide.setAttribute('aria-label', 'FAQ ' + (idx + 1));
            slide.innerHTML = '<h3 class="faq-question">' + labelEl.textContent + '</h3>' +
              '<p class="faq-answer">' + answer + '</p>';
            track.appendChild(slide);
          });
          originalNodes = Array.from(track.querySelectorAll('.swiper-slide'));
        }
      }
      const originalCount = originalNodes.length;
      if (originalCount === 0) return;

      const clonesCount = 1;
      let items = [];
      let cur = clonesCount;
      let perView = 1;
      let itemWidth = 0;
      let isTransitioning = false;
      let swipeThreshold = 20;

      function buildClones() {
        track.innerHTML = '';
        for (let i = 0; i < clonesCount; i++) {
          const node = originalNodes[(originalCount - clonesCount + i + originalCount) % originalCount].cloneNode(true);
          node.dataset.clone = 'true';
          track.appendChild(node);
        }
        originalNodes.forEach(function (n) { track.appendChild(n.cloneNode(true)); });
        for (let i = 0; i < clonesCount; i++) {
          const node = originalNodes[i % originalCount].cloneNode(true);
          node.dataset.clone = 'true';
          track.appendChild(node);
        }
        items = Array.from(track.children);
        cur = clonesCount;
      }

      buildClones();

      function applyTranslate(index, withTransition) {
        const gap = parseFloat(getComputedStyle(track).gap) || 16;
        const translateX = (itemWidth + gap) * index * -1;
        if (!withTransition) {
          track.style.transition = 'none';
          track.style.transform = 'translateX(' + translateX + 'px)';
          void track.offsetWidth;
          track.style.transition = '';
        } else {
          track.style.transform = 'translateX(' + translateX + 'px)';
        }
      }

      function mod(n, m) {
        return ((n % m) + m) % m;
      }

      function updateDots() {
        const dots = Array.from(dotsWrap.children);
        if (!dots.length) return;
        const centerIndex = cur + Math.floor(perView / 2);
        const originalCenter = mod(centerIndex - clonesCount, originalCount);
        dots.forEach(function (d, i) {
          d.classList.toggle('swiper-pagination-bullet-active', i === originalCenter);
        });
      }

      function updateActiveSlides() {
        const center = cur + Math.floor(perView / 2);
        items.forEach(function (it, i) {
          it.classList.toggle('swiper-slide-active', i === center);
        });
      }

      function update(skipDotRender) {
        applyTranslate(cur, true);
        if (prevBtn) { prevBtn.disabled = false; prevBtn.setAttribute('aria-disabled', 'false'); }
        if (nextBtn) { nextBtn.disabled = false; nextBtn.setAttribute('aria-disabled', 'false'); }
        if (!skipDotRender) updateDots();
        updateActiveSlides();
      }

      function prev() {
        if (isTransitioning) return;
        isTransitioning = true;
        cur = cur - 1;
        applyTranslate(cur, true);
      }

      function next() {
        if (isTransitioning) return;
        isTransitioning = true;
        cur = cur + 1;
        applyTranslate(cur, true);
      }

      track.addEventListener('transitionend', function () {
        isTransitioning = false;
        if (cur < clonesCount) {
          cur = cur + originalCount;
          applyTranslate(cur, false);
        }
        if (cur >= clonesCount + originalCount) {
          cur = cur - originalCount;
          applyTranslate(cur, false);
        }
        updateDots();
        updateActiveSlides();
      });

      function renderDots() {
        dotsWrap.innerHTML = '';
        for (let i = 0; i < originalCount; i++) {
          const b = document.createElement('button');
          b.className = 'swiper-pagination-bullet';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.dataset.pos = i;
          b.addEventListener('click', function () {
            cur = clonesCount + i;
            update();
          });
          dotsWrap.appendChild(b);
        }
        updateDots();
      }

      function calcLayout() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (vw < 520) perView = 1;
        else if (vw < 880) perView = 2;
        else perView = 3;

        const viewportWidth = viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(track).gap) || 16;
        const peek = 32;
        itemWidth = (viewportWidth - gap * (perView - 1) - peek) / perView;

        items.forEach(function (it) {
          it.style.flex = '0 0 ' + itemWidth + 'px';
          it.style.maxWidth = itemWidth + 'px';
        });

        if (cur < clonesCount) cur = clonesCount;
        if (cur >= clonesCount + originalCount) cur = clonesCount + (cur % originalCount);
        update(true);
        renderDots();
        updateActiveSlides();
        swipeThreshold = Math.max(20, itemWidth * 0.18);
      }

      var startX = 0, currentX = 0, isDown = false, startTranslate = 0;
      function onPointerDown(e) {
        isDown = true;
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        startTranslate = parseFloat(track.style.transform.replace(/translateX\(|px\)/g, '')) || 0;
        track.style.transition = 'none';
      }
      function onPointerMove(e) {
        if (!isDown) return;
        currentX = e.touches ? e.touches[0].clientX : e.clientX;
        var dx = currentX - startX;
        track.style.transform = 'translateX(' + (startTranslate + dx) + 'px)';
      }
      function onPointerUp(e) {
        if (!isDown) return;
        isDown = false;
        track.style.transition = '';
        var dx = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - startX;
        var threshold = typeof swipeThreshold !== 'undefined' ? swipeThreshold : Math.max(20, itemWidth * 0.18);
        if (dx > threshold) {
          prev();
        } else if (dx < -threshold) {
          next();
        } else {
          applyTranslate(cur, true);
        }
      }

      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { prev(); e.preventDefault(); }
        if (e.key === 'ArrowRight') { next(); e.preventDefault(); }
        if (e.key === 'Home') { cur = clonesCount; update(); e.preventDefault(); }
        if (e.key === 'End') { cur = clonesCount + originalCount - 1; update(); e.preventDefault(); }
      });

      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);
      window.addEventListener('resize', function () {
        items = Array.from(track.children);
        calcLayout();
      });

      track.addEventListener('mousedown', onPointerDown);
      track.addEventListener('mousemove', onPointerMove);
      window.addEventListener('mouseup', onPointerUp);
      track.addEventListener('touchstart', onPointerDown, { passive: true });
      track.addEventListener('touchmove', onPointerMove, { passive: true });
      track.addEventListener('touchend', onPointerUp);

      calcLayout();
      renderDots();
      applyTranslate(cur, false);
      updateActiveSlides();
    });
  });
})();
